module.exports = __webpack_public_path__ + "static/media/google-play-badge.235818b9.png";